import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { WorkCollage } from "../work/WorkCollage";
import { workApproach } from "../../data/portfolio";
import { cardHeading } from "../../utils/typography";
import type { WorkItem } from "../../types/work";
type WorkSectionProps = {
  onOpen: (item: WorkItem) => void;
};
export function WorkSection({
  onOpen
}: WorkSectionProps) {
  return <section id="work" aria-labelledby="work-heading" className="relative" data-id="element-302" data-mp="2qy0x0nweoi2y">
      <WorkCollage onOpen={onOpen} data-id="element-303" data-mp="2qvxuj4e2gwhc" />

      <div className="px-5 py-20 md:px-8 md:py-28" data-id="element-304" data-mp="2lyfvq6trjxn2">
        <div className="mx-auto max-w-[1480px]" data-id="element-305" data-mp="2lz7f8ja364wz">
          {/* One consolidated discipline statement rather than two competing columns. */}
          <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-10%"
        }} transition={{
          duration: 0.6
        }} className="group relative overflow-hidden rounded-[20px] border border-white/10 bg-[#0a0f0e] p-7 sm:p-9 md:p-12" data-id="element-306" data-mp="2cxzul40ht2ld">
            <span aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#54f6c6]/60 to-transparent" data-id="element-307" data-mp="222xjoouz58di" />

            <h3 className={`max-w-3xl ${cardHeading}`} data-id="element-308" data-mp="1t92n457x4q9h">
              {workApproach.heading.start} <span className="text-[#54f6c6]" data-id="element-309" data-mp="2gywz6kkeyaso">{workApproach.heading.accent}</span>
            </h3>

            <ul className="mt-8 grid max-w-4xl gap-6 md:mt-10" data-id="element-310" data-mp="2l0i6zri3byw0">
              {workApproach.points.map(point => <li key={point.description} className="flex gap-4 sm:gap-5" data-id="element-311" data-mp="2718up2x09oxb">
                  <span aria-hidden="true" className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#54f6c6]" data-id="element-312" data-mp="2bztu504fo4kp" />
                  <p className="text-[15px] leading-7 text-white/85 md:text-base md:leading-8" data-id="element-313" data-mp="vlu0u803fd6f">
                    {point.title && <span className="font-medium text-white" data-id="element-314" data-mp="10kx3jlslp7b8">{point.title}. </span>}
                    <span className="text-white/70" data-id="element-315" data-mp="giaoiikp8y69">{point.description}</span>
                  </p>
                </li>)}
            </ul>

            <div className="mt-10 border-t border-white/10 pt-7 md:mt-12" data-id="element-316" data-mp="chqsjibv40lp">
              <Link to="/videos" data-cursor="View" className="group relative inline-flex h-12 shrink-0 items-center gap-2 overflow-hidden rounded-xl bg-[#54f6c6] px-6 text-sm font-semibold text-[#05100d] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-317" data-mp="7p74tsjgnp36">
                <span aria-hidden="true" className="absolute inset-0 -translate-x-full bg-white/70 transition-transform duration-500 group-hover:translate-x-0" data-id="element-318" data-mp="3kwh78u7c1p82" />
                <span className="relative whitespace-nowrap" data-id="element-319" data-mp="3fzif2h78bsci">View all work</span>
                <ArrowUpRight className="relative h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-320" data-mp="1j42u08fqh8xz" />
              </Link>
            </div>
          </motion.article>
        </div>
      </div>
    </section>;
}